<template>
  <d-button-group class="buttons">
    <d-button size="sm" class="btn-info" @click.prevent="edit()">
      <i class="fas fa-pencil-alt"></i
      ><span class="d-none d-lg-inline"> Editar</span>
    </d-button>
    <div
      v-b-tooltip.hover="{
        variant: 'dark',
        title: isDisabled ? 'Região possui distribuidores associados' : null,
      }"
    >
      <d-button
        size="sm"
        class="btn-danger custom-button"
        @click.prevent="confirmDeleteRow()"
        :disabled="isDisabled"
      >
        <i class="fas fa-trash"></i>
        <span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </div>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_REGION_ } from '_modules/region/components/RegionModel';

export default {
  name: 'region-buttons',
  props: {
    region: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isDisabled() {
      return this.region.resellers_count > 0;
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    blockAccess() {},
    edit() {
      this.$router.push(`/admin/regiao/${this.region.id}`);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_REGION_, this.region);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.custom-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
